export default "__VITE_ASSET__caf874f8__"